module.exports = __webpack_public_path__ + "static/media/revcarter.18d34343.PNG";